import { SagaIterator } from 'redux-saga'

// web-only sagas
export default function* platformSaga(): SagaIterator {
	/* Intentionally left blank */
}
